import { KoBadge, KoBreadcrumb, KoButton, KoForm, KoLoader, KoModal, KoText, KoTicketTable, KoTitle, KoToast, KoTooltips } from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { add, remove } from 'shared/store/breadcrumbSlice';
import { DevelopmentAPI } from '../development.service';
import styles from './epic.module.scss';
import { getTicketBreadCrumb } from 'shared/commonConstants';
import EpicTaskCrud from '../task/epicCurd';
import KoTicketTable_COLUMNS from './constant';
import TaskCrud from '../task/crud';
import CommnetsModal from 'shared/components/modals/comments';

const Epic = (props) => {
  const { workspaceId } = useParams();
  const { profile } = props;
  const workspaceById = useSelector(state => state?.workspaceById);
  const workspaceDetails = workspaceById['data'];
  const [isCommnetsModalOpen, setCommnetsModal] = useState(false);
  const [isOpenCommentsModal, setCreateComment] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [currentTicket, setCurrentTicket] = useState();
  const [openSubModel, setSubModel] = useState(false);
  const [subTotalCount, setSubTotalCount] = useState(100);
  const [subCurrentRecord, setSubCurrentRecord] = useState({
    status: 1,
    issueType: 2,
    priority: 3
  });

  const dispatch = useDispatch();
  const userById = useSelector(state => state?.userById);
  const [isLoading, setLoading] = useState(false);
  const [epics, setEpics] = useState();
  const [isOpen, setModal] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [isSubLoading, setSubLoading] = useState(false);
  const [isHandleAddCreate, setHandleAddCreate] = useState();
  const [isIssueModel, setIssueModel] = useState('main');
  const [breadCrumbs, setBreadCrumbs] = useState();
  const [isOpenEpic, setModalEpic] = useState(false);
  const [epicData, setEpicData] = useState();
  const [pagination, setPagination] = useState({
    size: 100,
    page: 1,
    issueType: 1,
    limit: 100
  });
  const [subPagination, setSubPagination] = useState({
    size: 10,
    page: 1
  });
  let userDetails = userById['data'];
  const [dueCurrentRecord, setDueCurrentRecord] = useState({
    status: 1,
    issueType: 2,
    priority: 3,
    reporter: userDetails?.userId
  });


  const [currentRecord, setCurrentRecord] = useState({
    status: 1,
    issueType: 2,
    priority: 3,
    reporter: userDetails && userDetails?.userId
  });

  const [form] = KoForm.useForm();



  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      {
        title: 'workspace',
        path: 'workspace'
      },
      {
        title: workspaceDetails?.name
      },
      {
        title: 'BackLogs'
      }
    ]));

  }, [workspaceDetails]);

  useEffect(() => {
    getEpics();
  }, []);


  const getEpics = () => {
    setLoading(true);
    DevelopmentAPI.getEpics(pagination, workspaceId).then(
      (data) => {
        setTotalCount();
        setEpics();
        setLoading(false);
        setEpics(data?.epics);
        setTotalCount(data?.totalCount);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const handleFinish = (values, epicId) => {
    setLoading(true);

    values.issueType = 1;
    values.epic = currentRecord?.epicId;
    DevelopmentAPI.createEpicOrUpdate(
      values,
      currentRecord?.epicId,
      workspaceId
    ).then(
      (data) => {
        setLoading(false);
        form.resetFields();
        setModalEpic(false);
        getEpics();
        KoToast.success(
          `Epic ${currentRecord?.epicId ? "updated" : "created"} successfully`
        );
      },
      (err) => {
        setLoading(false);
      }
    );

  };


  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(pagination, query);
    setPagination(p);
    getEpics(p);
  };

  const onSearchText = (text) => {
    let q = pagination;
    q['search'] = text;
    getEpics(q);
  };

  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getEpics(q);
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Comments'}>
          <KoBadge count={row?.commentsCount} >
            <KoButton onClick={() => setCommnetsModal(true)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ChatOutlined'} />} />
          </KoBadge>
        </KoTooltips>
        <KoTooltips title={'Issues'}>
          <KoBadge count={row?.ticketsCount} >
            <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'IssuesOutlined'} />} onClick={() => getIssueById(row)} />
          </KoBadge>
        </KoTooltips>
        <KoTooltips title={row?.issueType !== 4 ? 'Add Issues' : 'Add Issues'}>
          <div onClick={() => setHandleAddCreate(true)} style={{ visibility: row?.issueType === 4 ? 'hidden' : '' }}>
            <KoIcon width={18} height={18} name={'PlusFilled'} />
          </div>
        </KoTooltips>
        <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} onClick={() => setModalEpic(true)} />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setDeleteModal(true)} />
        </KoTooltips>
      </div>;
    }
  }];

  const onChangeStatus = (key) => {
    let q = pagination;
    if (key) {
      q['status'] = key.toString();
    } else {
      delete q?.['status'];
    }

    getEpics(q);
  };

  const onChangePriority = (key) => {
    let q = pagination;
    if (key) {
      q['priority'] = key.toString();
    } else {
      delete q?.['priority'];
    }

    getEpics(q);
  };

  const onChangeAssignees = (key) => {
    let q = pagination;
    if (key) {
      q['assignee'] = key.toString();
    } else {
      delete q?.['assignee'];
    }

    getEpics(q);
  };

  const onExtraClick = (row) => {
    setCurrentRecord(row);
    // const updatedRoomObj = { ...row, source: 'tickets' };
    // dispatch(setSelectedChatData(updatedRoomObj));
    // dispatch(setSelectedChatType('tickets'));
    let crums = getTicketBreadCrumb(row, workspaceDetails);
    setBreadCrumbs(crums);

  };

  const getIssueById = (row) => {
    setCurrentRecord(row);
    setSubLoading(true);
    DevelopmentAPI.getEpicIssuesCount(row?.epicId, workspaceId).then(
      (data) => {
        setSubLoading(false);
        setCurrentTicket(data['tickets']);
        setSubTotalCount(data?.totalCount);
        setSubModel(true);
      },
      (err) => {
        setSubLoading(false);
      }
    );
  };

  const deleteIssues = () => {
    setLoading(true);
    DevelopmentAPI.deleteEpic(currentRecord?.epicId, workspaceId).then(
      (data) => {
        setLoading(false);
        setCurrentRecord();
        setDeleteModal(false);
        getEpics();
        KoToast.success(
          `Epic deleted successfully`
        );
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onSubPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(subPagination, query);
    setSubPagination(p);
    getIssueById(currentRecord.epicId, p);
  };

  const onSubSearchText = (text) => {
    let q = subPagination;
    q['search'] = text;
    getIssueById(currentRecord.ticketId, q);
  };

  const onSubSort = (key, type) => {
    let q = subPagination;
    q['sort'] = `${key}:${type}`;
    getIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubStatus = (key) => {
    let q = subPagination;
    if (key) {
      q['status'] = key.toString();
    } else {
      delete q?.['status'];
    }

    getIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubType = (key) => {
    let q = subPagination;
    if (key) {
      q['issueType'] = key.toString();
    } else {
      delete q['issueType'];
    }
    getIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubPriority = (key) => {
    let q = subPagination;
    if (key) {
      q['priority'] = key.toString();
    } else {
      delete q?.['priority'];
    }

    getIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubAssignees = (key) => {
    let q = subPagination;
    if (key) {
      q['assignee'] = key.toString();
    } else {
      delete q?.['assignee'];
    }

    getIssueById(currentRecord.ticketId, q);
  };

  return (
    <div className="tableCard">
      {isLoading && <KoLoader />}

      <KoTicketTable
        title="Epics"
        setModal={setModal}
        onSearchText={onSearchText}
        profile={profile}
        getIssueById={getIssueById}
        API={DevelopmentAPI}
        columns={KoTicketTable_COLUMNS}
        onSort={onSort}
        workspaceId={workspaceId}

        isEpic={setModalEpic}
        rowKey="epicId"
        refreshData={getEpics}
        getTicketsList={getEpics}
        setLoading={setLoading}
        onChangeStatus={onChangeStatus}
        onChangePriority={onChangePriority}
        onChangeAssignees={onChangeAssignees}
        isCommnetsModalOpen={isCommnetsModalOpen}
        setCommnetsModal={() => setCommnetsModal(false)}
        setCurrentRecord={(record) => {
          setCurrentRecord(record);
          setIssueModel('main');
        }}
        isOpen={isOpen}
        Bulk={{
          visible: false
        }}
        RowSelectionOption={{
          visible: true
        }}
        tickets={epics}
        onExtraClick={onExtraClick}
        extraColumnsRight={columnsRight}
        onPagination={onPagination}
        pagination={{ page: pagination.page, limit: pagination.limit }}
        totalCount={totalCount} />
      {isCommnetsModalOpen && <CommnetsModal
        workspaceId={currentRecord?.workspace}
        setCommnetsModal={() => setCommnetsModal(false)}
        ticketId={currentRecord.epicId}
        classNameMain={styles.wrapperOverflow}
        isCommnetsModalOpen={isCommnetsModalOpen}
        epicId={isIssueModel === 'main' ? currentRecord?.epicId : isIssueModel === 'due' ? dueCurrentRecord?.ticketId : subCurrentRecord?.ticketId}
        setCreateComment={setCreateComment}
        isCommentsModal={isOpenCommentsModal}
      />}

      <KoModal
        title={
          breadCrumbs ? (
            <KoBreadcrumb items={breadCrumbs} />
          ) : epicData?.epicId ? (
            `Update Epic ${(epicData?.epicId).toUpperCase()}`
          ) : (
            `Create Epic`
          )
        }
        centered
        open={isOpenEpic}
        afterClose={() => {
          setEpicData();
        }}
        handleOk={() => {
          setEpicData();
          setModalEpic(false);
        }}
        onClose={() => {
          setModalEpic(false);
        }}
        width={"95vw"}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => {
              setModalEpic(!isOpenEpic);
              form.resetFields();
            }}
          />,
          <KoButton
            key="create"
            loading={isLoading}
            type="primary"
            label={currentRecord?.epicId ? `Update` : `Create`}
            onClick={() => form.submit()}
          />
        ]}
      >
        <EpicTaskCrud
          form={form}
          handleFinish={handleFinish}
          initialValues={currentRecord}
          profile={profile}
          epic={true}
          epicId={currentRecord?.epicId || null}
        />
      </KoModal>

      <KoModal
        title={
          breadCrumbs ? (
            <KoBreadcrumb items={breadCrumbs} />
          ) : epicData?.epicId ? (
            `Update Epic ${(epicData?.epicId).toUpperCase()}`
          ) : (
            `Create Epic`
          )
        }
        centered
        open={isHandleAddCreate}
        afterClose={() => {
          setEpicData();
        }}
        handleOk={() => {
          setEpicData();
          setHandleAddCreate(false);
        }}
        onClose={() => {
          setHandleAddCreate(false);
        }}
        width={"95vw"}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => {
              setHandleAddCreate(!isHandleAddCreate);
              form.resetFields();
            }}
          />,
          <KoButton
            key="create"
            loading={isLoading}
            type="primary"
            label={`Create`}
            onClick={() => form.submit()}
          />
        ]}
      >
        <TaskCrud
          form={form}
          handleFinish={handleFinish}
          initialValues={currentRecord}
          profile={profile}
          epic={true}
          epicId={currentRecord?.epicId || null}
        />
      </KoModal>

      <KoModal
        title={`Delete Epic ${currentRecord?.epicId?.toUpperCase()}`}
        centered
        open={isOpenDelete}
        afterClose={() => {
          setCurrentRecord();
        }}
        handleOk={() => {
          setCurrentRecord();
          setDeleteModal(false);
        }}
        onClose={() => {
          setCurrentRecord();
          setDeleteModal(false);
        }}
        width={580}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => setDeleteModal(!isOpenDelete)}
          />,
          <KoButton
            key="delete"
            loading={isLoading}
            type="primary"
            label="Delete Epic"
            onClick={() => deleteIssues()}
          />
        ]}
      >
        <div className={styles.wrapperModal}>
          <KoTitle
            level={5}
            text={`This action will delete item and cannot be undone`}
          />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>

      <KoModal
        title={`${currentRecord?.epicId?.toUpperCase()} issues`}
        centered
        open={openSubModel}
        afterClose={() => {
          setDueCurrentRecord();
          setCurrentTicket();
          setBreadCrumbs();
        }}

        handleOk={() => {
          setDueCurrentRecord();
          setCurrentTicket();
          setSubModel(false);
        }}
        onClose={() => {
          setDueCurrentRecord();
          setCurrentTicket();
          setSubModel(false);
        }}
        // maskClosable={false}
        width={`95vw`}
        footer={[]}>
        <>
          {isSubLoading && <KoLoader circle={false} />}
          <KoTicketTable
            setModal={setModal}
            onSearchText={onSubSearchText}
            profile={profile}
            API={DevelopmentAPI}
            getIssueById={getIssueById}
            onSort={onSubSort}
            rowKey="ticketId"
            onChangeStatus={onChangeSubStatus}
            onChangeType={onChangeSubType}
            onChangePriority={onChangeSubPriority}
            onChangeAssignees={onChangeSubAssignees}
            setLoading={setSubLoading}
            setCurrentRecord={(record) => {
              setSubCurrentRecord(record);
            }}
            isOpen={openSubModel}
            maxHeight={100}
            Bulk={{
              visible: false
            }}
            RowSelectionOption={{
              visible: false
            }}
            setBreadCrumbs={setBreadCrumbs}
            createBtn={false}
            tickets={currentTicket}
            columnsRight={columnsRight}
            setCommnetsModal={setCommnetsModal}
            onPagination={onSubPagination}
            currentRecord={subCurrentRecord}
            pagination={{
              page: subPagination.page,
              limit: subPagination.limit
            }}
            totalCount={subTotalCount}
          />
        </>
      </KoModal>
    </div>
  );
};

export default Epic;